import { Injectable } from '@angular/core';
import { ICostinglevelArticleMappingLayout } from '../../models/layout/costinglevel-article-mapping-layout.model';

@Injectable({
    providedIn: 'root',
})
export class CostinglevelArticleMappingLayoutService {

    constructor() {
    }

    public getCostinglevelArticleMappingLayout(): ICostinglevelArticleMappingLayout {
        return {
            columns: [ 'costingLevelName', 'articleNr' ],
        };
    }
}
